import { Link } from 'react-router-dom';
import { Wordmark } from '../components/Logo';

export default function NotFound() {
  return (
    <main className="min-h-dvh grid place-items-center p-6 text-center">
      <div>
        <Wordmark height={40} />
        <h1 className="mt-6">الصفحة غير موجودة</h1>
        <p className="muted mt-2">تأكد من الرابط أو امسح رمز المحل من جديد.</p>
        <Link to="/" className="btn btn-ghost mt-6">الصفحة الرئيسية</Link>
      </div>
    </main>
  );
}
